import { X } from 'lucide-react'
import { Button } from '@/components/orders/Button'
import { useConnectionHealth } from '@/providers/ConnectionHealthProvider'

interface ConnectionHealthBannerProps {
  className?: string
}

const ConnectionHealthBanner = ({ className = '' }: ConnectionHealthBannerProps) => {
  const { showBanner, dismissBanner } = useConnectionHealth()

  const handleReload = () => {
    window.location.reload()
    dismissBanner()
  }

  if (!showBanner) {
    return null
  }

  return (
    <div
      className={`w-full bg-danger/20 text-white px-4 flex items-center justify-between shadow-lg border-b border-danger ${className}`}
      role="alert"
    >
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0">
          <svg className="w-5 h-5 animate-pulse" fill="currentColor" viewBox="0 0 20 20">
            <path
              fillRule="evenodd"
              d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="flex-1">
          <p className="text-lg font-bold">
            Connection lost. Data may be out of date. Reconnecting…
          </p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="ghost" className="text-white mr-4" onClick={handleReload}>
          Reload
        </Button>
        <button
          onClick={dismissBanner}
          className="flex items-center justify-center w-8 h-8 rounded-full hover:bg-red-500 transition-colors duration-200"
          aria-label="Dismiss connection warning"
          title="Dismiss warning"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  )
}

export default ConnectionHealthBanner
